import { createHead } from '@unhead/vue';
import { defineAppPlugin } from '/app/utils/app';

const head = createHead();

export default defineAppPlugin(({ app }) => {
    app.use(head);
});